<div class="linear-container__summary">
    <div class="linear-container__summary__stake-area">
        <bs-linear-container-total-odds
            *ngIf="showOdds && !!oddsDisplayFormat"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [indicateOddsChange]="indicateOddsChange"></bs-linear-container-total-odds>
        <bs-linear-container-stake [bsLinearStakeScroll]="'.betslip-edit-state__type-list'" [isDisabled]="isDisabled"></bs-linear-container-stake>
    </div>

    <bs-linear-container-possible-winnings *ngIf="showSummary$ | async"></bs-linear-container-possible-winnings>
</div>
